import { BrowserRouter, Route, Routes } from 'react-router-dom'

import NotFound from 'pages/NotFound'

function ErrorApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='*' element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

export default ErrorApp
